const eventCountdownElem = document.querySelectorAll('[data-timer]');

eventCountdownElem.forEach((el) => {
  const eventTime = el.getAttribute('data-timer');
  const daysElem = el.querySelector('.timer-days');
  const hoursElem = el.querySelector('.timer-hours');
  const minutesElem = el.querySelector('.timer-minutes');
  const secondsElem = el.querySelector('.timer-seconds');

  const leadingZero = (time) => (time < 10 ? `0${time}` : time);

  // Set the date we're counting down to
  const countDownDate = new Date(eventTime).getTime();

  // Update the count down every 1 second
  const x = setInterval(() => {
    el.classList.add('is-visible');

    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = countDownDate - now;

    // Output the result in an element with id="demo"
    daysElem.innerHTML = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hh = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const mm = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const ss = Math.floor((distance % (1000 * 60)) / 1000);
    hoursElem.innerHTML = leadingZero(hh);
    minutesElem.innerHTML = leadingZero(mm);
    secondsElem.innerHTML = leadingZero(ss);

    if (Math.floor(distance / (1000 * 60 * 60 * 24)) < 1 && !el.classList.contains('hide-day')) {
      el.classList.add('hide-day');
    }

    if (daysElem.innerHTML < 3) {
      el.querySelector('.days').style.display = 'none';
      el.querySelector('.days-2').style.display = 'inline';
    }

    if (daysElem.innerHTML < 2) {
      el.querySelector('.days-2').style.display = 'none';
      el.querySelector('.days-1').style.display = 'inline';
    }

    if (daysElem.innerHTML < 1) {
      daysElem.style.display = 'none';
      el.querySelector('.timer-label').style.display = 'none';
    }

    if (daysElem.innerHTML < 1 && hh < 1 && mm < 10) {
      const streamWrapper = document.querySelector('.video__wrapper--stream');
      streamWrapper?.classList.add('is-clickable');
    }

    // If the count down is over, write some text
    if (distance < 0) {
      clearInterval(x);
      el.classList.add('is-live');
    }
  }, 1000);
});
